import { TopicsState } from './topics.state';

export const HomeState = [TopicsState];

export * from './topics.actions';
export * from './topics.state';
